// extracted by mini-css-extract-plugin
export var copyableField = "_hz-4";
export var customerBadge = "_hz-0";
export var customerInfoTitle = "_hz-2";
export var details = "_hz-1";
export var dropdownContainer = "_hz-5";
export var dropdownImage = "_hz-6";
export var editAssigneeForm = "_hz-a";
export var editButton = "_hz-3";
export var email = "_hz-7";
export var hidden = "_hz-d";
export var input = "_hz-8";
export var saveButton = "_hz-b";
export var shopifyIcon = "_hz-c";
export var suggestionBadge = "_hz-e";
export var suggestionText = "_hz-f";
export var username = "_hz-9";